<script setup lang="ts">
const items = [
  {
    title: 'Melalui API KiriminAja',
    primary: true,
    assetUrl: '/images/integration-api-kiriminaja-api.svg',
    lists: [
      {
        title: '1-2 Minggu',
        icon: 'material-symbols:rocket-launch-outline',
        description:
          'Hanya membutuhkan sedikit waktu untuk mengintegrasikan ke toko online-mu.'
      },
      {
        title: 'Integrasi 15+ Ekspedisi',
        icon: 'material-symbols:dashboard-customize-outline',
        description:
          'Jumlah ekspedisi yang langsung terhubung melalui API KiriminAja dalam satu kali integrasi.'
      }
    ]
  },
  {
    title: 'Melalui API Ekspedisi',
    assetUrl: '/images/integration-api-expedition-api.svg',
    lists: [
      {
        title: '2-3 Bulan',
        icon: 'material-symbols:block-outline',
        description:
          'Butuh waktu integrasi lebih banyak dengan memproses satu per satu ke ekspedisi.'
      },
      {
        title: 'Integrasi Satu-Satu',
        icon: 'material-symbols:sentiment-very-dissatisfied-outline-rounded',
        description:
          'Selesai integrasi ke satu ekspedisi, masih harus kembali mengintegrasikan dengan ekspedisi lain.'
      }
    ]
  }
]
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-12">
    <UiSectionTitle
      class="lg:text-center"
      title="Proses Integrasi Lebih Cepat dengan API KiriminAja"
      description="Cukup satu kali integrasi untuk semua ekspedisi. Optimalkan proses pengiriman bisnismu tanpa perlu integrasi satu per satu."
    />

    <div
      class="flex flex-col md:flex-row justify-center items-stretch gap-6 lg:gap-10"
    >
      <UiCardFeature
        v-for="(item, index) in items"
        :key="index"
        class="flex-1 md:max-w-sm border border-surface-container-high"
        wrapper-class="p-0 relative overflow-hidden"
        :radial-color="item.primary ? undefined : 'var(--color-error)'"
      >
        <div
          class="rounded-lg py-5 w-full px-2"
          :class="{
            'bg-tertiary-container': !item.primary,
            'bg-secondary-container': item.primary
          }"
        >
          <p class="font-bold text-center">{{ item.title }}</p>
          <img :src="item.assetUrl" :alt="item.title" class="mx-auto mt-5" />
        </div>
        <div class="flex flex-col gap-4 p-4 pt-3.5">
          <div
            v-for="(list, listIndex) in item.lists"
            :key="`${index}-${listIndex}`"
            class="flex gap-3 p-4 rounded-xl border border-surface-container-highest"
          >
            <div
              class="shrink-0"
              :class="{
                'text-error': !item.primary,
                'text-primary': item.primary
              }"
            >
              <Icon :name="list.icon" size="24px" />
            </div>
            <div class="flex flex-col gap-2">
              <p class="font-bold">{{ list.title }}</p>
              <p class="text-sm text-outline">{{ list.description }}</p>
            </div>
          </div>
        </div>
      </UiCardFeature>
    </div>
  </UiContainer>
</template>
